import Vue from "vue"

import NavigationBarComponent from "./NavigationBar.vue"
import AlertTipComponent from "./AlertTip.vue"
import TitleComponent from "./title.vue"
import ImageComponent from "./Image.vue"
import ProjectTitleComponent from "./projectTitle.vue"
import ScrollComponent from "./Scroll.vue"
import TextPromptComponent from './TextPrompt.vue';

const Components = {};
Components.install=function(){
    Vue.component("Navigation-bar", NavigationBarComponent);
    Vue.component("Alert-tip", AlertTipComponent);
    Vue.component("Title", TitleComponent);
    Vue.component("YD-image", ImageComponent);
    Vue.component("Project-title", ProjectTitleComponent);
    Vue.component("Scroll", ScrollComponent);
    Vue.component("Text-prompt", TextPromptComponent)
}


export default Components;